import React from 'react';
import DashboardLayout from '../components/layout/DashboardLayout';

const ViewOnlineResults: React.FC = () => {
  return (
    <DashboardLayout>
      <div className="p-4">
        <div className="card bg-white rounded-sm p-4 border border-slate-300">
          <h2 className="text-lg font-bold text-slate-800 mb-4">مشاهده آنلاین جواب</h2>
          <p className="text-slate-600 mb-4">
            در این بخش می‌توانید نتایج آزمایش‌های خود را به صورت آنلاین مشاهده نمایید.
          </p>
          
          <div className="bg-green-50 border border-green-200 rounded-md p-4 mb-6">
            <div className="flex items-center">
              <svg className="w-5 h-5 text-green-500 ml-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <p className="text-green-700 text-sm">
                نتایج آزمایش‌های تایید شده در این بخش به صورت آنلاین قابل مشاهده است.
              </p>
            </div>
          </div>

          <div className="space-y-4">
            <div className="text-center py-12 text-gray-500">
              <svg className="mx-auto h-12 w-12 text-gray-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <p className="text-sm">
                هنوز نتیجه آزمایشی برای مشاهده آنلاین در دسترس نیست
              </p>
              <p className="text-xs text-gray-400 mt-2">
                نتایج آزمایش‌های تایید شده در این قسمت نمایش داده خواهد شد
              </p>
            </div>
          </div>

          <div className="mt-6 p-4 bg-gray-50 rounded-md">
            <h3 className="text-sm font-medium text-gray-800 mb-2">راهنمای استفاده:</h3>
            <ul className="text-sm text-gray-600 space-y-1">
              <li>• پس از تایید نتایج توسط آزمایشگاه، نتایج در این بخش نمایش داده می‌شود</li>
              <li>• می‌توانید نتایج را مشاهده کرده و در صورت نیاز پرینت بگیرید</li>
              <li>• برای دریافت فایل PDF نتایج از بخش مربوطه استفاده کنید</li>
            </ul>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ViewOnlineResults; 